import { ReferralSourceModel } from './referralSourceModel';

export class EditReferralSourceModel extends ReferralSourceModel {
}
